import React from 'react';
import CreatorCard from '../commonElements/creatorCard';
import CreatorTitle from '../commonElements/creatorTitle';
import { PLATFORM_COLORS, PLATFORM_ICONS } from '../../../../config/icons';
import { useSelector } from 'react-redux';
import { ALL, GENERIC } from '../../../../config/constants';

const PublishedOn: React.FC = () => {
  const { postData, has_been_published } = useSelector(
    (state: any) => state.lomavisCreator
  );
  const openUrl = (url: string) => {
    window.open(url, '_blank');
  };
  // only show the component when post is published and has a platform url
  const hasPlatformUrl = Object.keys(postData).some(
    (platform) => postData?.[platform]?.platform_url
  );
  if (!hasPlatformUrl || !has_been_published) return null;
  return (
    <CreatorCard>
      <CreatorTitle title="published_on" tooltipPosition="right" />
      <div className="d-flex">
        {Object.keys(postData).map((platform) => {
          if (!postData?.[platform]?.platform_url) return null;
          if (platform === GENERIC || platform === ALL) return null;
          return (
            <i
              className={
                (PLATFORM_ICONS[platform] as string) +
                ' fs-2x me-4 cursor-pointer h-20px'
              }
              style={{ color: PLATFORM_COLORS[platform] }}
              key={platform}
              onClick={() => {
                openUrl(postData[platform].platform_url);
              }}
            ></i>
          );
        })}
      </div>
      <div className="mb-3" />
    </CreatorCard>
  );
};

export default PublishedOn;
